/* eslint-disable */
import _ from 'lodash';
import qs from 'qs';

const initialState = {
  incentives: [],
  incentive: [],
  paging: {
    number: 1,
    size: 20
  },
  meta: [],
  fetching: false,
  fetched: false,
  errors: {}
};

export default function incentivesReducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_INCENTIVE_PENDING':
    case 'ADD_INCENTIVES_PENDING':
    case 'GET_INCENTIVES_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case 'GET_INCENTIVE_FULFILLED': {
      const data = action.payLoad.data;
      const meta = action.payLoad.meta;
      const newMeta = meta;

      const incentiveTypes = {};

      // TODO remove
      _.each(meta['incentive-types'], (value, key) => {
        key = key.replace(/-/g, '_');
        incentiveTypes[key] = value;
      });
      newMeta['incentive-types'] = incentiveTypes;

      return {
        ...state,
        fetching: false,
        fetched: true,
        incentive: data,
        meta: newMeta
      };
    }
    case 'ADD_INCENTIVE_FULFILLED': {
      return {
        ...state
      };
    }
    case 'GET_INCENTIVES_FULFILLED': {
      const lastPage = action.payLoad.links.last;
      let page = state.paging;

      if (lastPage) {
        page = qs.parse(lastPage.split('?')[1]).page;
      } else if (Object.keys(action.payLoad.links).length === 0) {
        page = initialState.paging;
      }

      return {
        ...state,
        fetching: false,
        fetched: true,
        incentives: action.payLoad.data,
        paging: page
      };
    }
    case 'GET_INCENTIVE_REJECTED':
    case 'ADD_INCENTIVES_REJECTED':
    case 'GET_INCENTIVES_REJECTED': {
    }
    default: {
      return {...state};
    }
  }
}
